import router, {resetRouter} from '@router'
import {defaultRoutes} from '@router/routes'
import {getPermissionRoutes} from '@router/permission'
import store from '@store'
import http from '@/axios'
import {cancelRequestAll} from '@/axios/cancel'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false });// NProgress 配置

/**
 * 路由守卫
 */
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  cancelRequestAll();
  if (to.path === "/login") {
    const loginMobile = localStorage.getItem("loginMobile");
    const loginAccount = localStorage.getItem("loginAccount");
    resetRouter();// 重置路由
    localStorage.clear();// 清除session
    store.commit("clearData");// 清除vuex的值
    loginMobile && localStorage.setItem("loginMobile", loginMobile);
    loginAccount && localStorage.setItem("loginAccount", loginAccount);
    next();
  } else if (!store.state.token) {// 未登录或非白名单跳转登录页面
    to?.meta?.allow ? next() : next("/login");
  } else if (!store.state.permissions) {
    const res = await http.getPermissions(); // 未获得权限时后台查询并生成对应的路由
    if (res) {
      const data = res.data || [];
      const menuList = data.filter(item => item.method === "MENU").map(item => item.resource);
      const apiList = data.filter(item => item.method !== "MENU").map(item => `${item.method.toLowerCase()}_${item.resource}`);
      store.commit("setPermission", menuList);
      store.commit("setApi", apiList);
      const permissionRoutes = getPermissionRoutes(menuList);
      router.addRoutes([
        ...permissionRoutes,
        ...defaultRoutes,
      ]);
      next({...to, replace: true});
    }
  } else {
    next();
  }
  NProgress.done();
});
